import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { AdminRoute } from "@/components/auth/AdminRoute";
import AdminTransactions from "@/pages/admin/AdminTransactions";

export const Route = createFileRoute("/admin/transacoes")({
  head: () => seoHead({
    title: "Administração | Shopping do Bem",
    description: "Área administrativa do Shopping do Bem.",
    noindex: true,
  }),
  component: () => (
    <AdminRoute>
      <AdminTransactions />
    </AdminRoute>
  ),
});
